// extracted by mini-css-extract-plugin
export default {"iconInfo":"styles_iconInfo__9-AKI","item":"styles_item__DUh2r","title":"styles_title__btXNs","text":"styles_text__9LdwO"};